import { render } from "./PostBody.vue?vue&type=template&id=5d59fa9a&scoped=true"
import script from "./PostBody.vue?vue&type=script&lang=js"
export * from "./PostBody.vue?vue&type=script&lang=js"

import "./post-body.scss?vue&type=style&index=0&id=5d59fa9a&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d59fa9a"]])

export default __exports__